import { ManageUserFilter } from '../modals/ManageUserFilter';
import { ManageUserFilterContext } from '../modals/ManageUserFilterContext';

export const initializeFilterState = (filters: ManageUserFilterContext) => {
  const initialFilter: ManageUserFilter = {
    country: filters.country || [],
    userTypes: filters.userTypes || [],
  };
  return initialFilter;
};

// Check if filters have been modified or not
export const checkIfFiltersChanged = (filterObj: ManageUserFilter): boolean => {
  return filterObj.country.length > 0 || filterObj.userTypes.length > 0;
};
